/**
 * 功能权限树（与后端 PermissionPoints 保持一致）
 * 三级：模块 -> 功能项 -> 操作，权限点 key = module.func.op
 */

const V = {code: 'view', name: '查看'};
const E = {code: 'edit', name: '编辑'};
const AUD = {code: 'audit', name: '审核'};
const IMP = {code: 'import', name: '导入'};
const EXP = {code: 'export', name: '导出'};
const ORG = {code: 'organize', name: '整理凭证'};
const DEL = {code: 'delete', name: '删除'};
const PRT = {code: 'print', name: '打印'};
const CFG = {code: 'config', name: '配置'};
const GEN = {code: 'generate', name: '生成凭证'};
const CHG = {code: 'change', name: '变更'};
const DSP = {code: 'dispose', name: '处置'};
const DPR = {code: 'depreciate', name: '计提折旧'};
const MSB = {code: 'modifySubject', name: '修改科目'};
const FST = {code: 'fieldSetting', name: '字段设置'};
const CKO = {code: 'checkout', name: '结账'};
const UCK = {code: 'uncheckout', name: '反结账'};
const FET = {code: 'fetch', name: '获取申报信息'};
const ONE = {code: 'onetap', name: '一键申报'};
const TAC = {code: 'taxAccount', name: '税务账号设置'};
const FIL = {code: 'fill', name: '填报'};
const RST = {code: 'reset', name: '重置'};
const CST = {code: 'codeSetting', name: '编码设置'};
const INV = {code: 'invoice', name: '开票'};
const IVI = {code: 'invoiceItem', name: '开票项目'};
const TXI = {code: 'taxInfo', name: '税务信息'};
const IVS = {code: 'invoiceSetting', name: '开票设置'};
const IVO = {code: 'invoiceOrder', name: '发票订单'};
const BIV = {code: 'batchInvoice', name: '批量开票'};

export const MODULES = ['凭证', '账簿', '报表', '资金', '工资', '发票', '固定资产', '存货', '期末结转', '申报', '设置', '备忘录'];

export const TREE = [
	{
		code: 'voucher', name: '凭证', funcs: [
			{code: 'voucher', name: '凭证', ops: [V, E, AUD, IMP, EXP, ORG, DEL, PRT]},
			{code: 'bizVoucher', name: '业务凭证', ops: [V, CFG, E, GEN]}
		]
	},
	{
		code: 'book', name: '账簿', funcs: [
			{code: 'detail', name: '明细账', ops: [V, EXP, PRT]},
			{code: 'general', name: '总账', ops: [V, EXP, PRT]},
			{code: 'subjectBalance', name: '科目余额表', ops: [V, EXP, PRT]},
			{code: 'subjectSummary', name: '科目汇总表', ops: [V, EXP, PRT]},
			{code: 'journal', name: '序时账', ops: [V, EXP, PRT]},
			{code: 'auxDetail', name: '核算项目明细账', ops: [V, EXP, PRT]},
			{code: 'auxBalance', name: '核算项目余额表', ops: [V, EXP, PRT]}
		]
	},
	{
		code: 'report', name: '报表', funcs: [
			{code: 'balanceSheet', name: '资产负债表', ops: [V, E, EXP, PRT]},
			{code: 'profitSheet', name: '利润表', ops: [V, E, EXP, PRT]},
			{code: 'cashFlowSheet', name: '现金流量表', ops: [V, E, EXP, PRT]},
			{code: 'customReport', name: '自定义报表', ops: [V, E, DEL]}
		]
	},
	{
		code: 'funds', name: '资金', funcs: [
			{code: 'dayAccount', name: '日记账', ops: [V, E, DEL, IMP, EXP, PRT, GEN]},
			{code: 'generateSetting', name: '生成凭证设置', ops: [V, E, DEL]},
			{code: 'innerTransfer', name: '内部转账', ops: [V, E, DEL, IMP, EXP, PRT, GEN]},
			{code: 'fundsReport', name: '资金报表', ops: [V, EXP, PRT]},
			{code: 'checkLedger', name: '核对总账', ops: [V, EXP, PRT]},
			{code: 'incomeCategory', name: '收支类别', ops: [V, E, DEL]},
			{code: 'accountSetting', name: '账户设置', ops: [V, E, DEL]}
		]
	},
	{
		code: 'salary', name: '工资', funcs: [
			{code: 'salarySheet', name: '工资表', ops: [V, E, DEL, AUD, IMP, EXP, PRT, GEN]},
			{code: 'voucherSetting', name: '工资凭证设置', ops: [V, E, DEL]},
			{code: 'salaryItem', name: '工资项目', ops: [V, E, DEL]},
			{code: 'employeeInfo', name: '员工信息', ops: [V, E, DEL, IMP, EXP]},
			{code: 'insuranceSetting', name: '五险一金设置', ops: [V, E, DEL]}
		]
	},
	{
		code: 'invoice', name: '发票', funcs: [
			{code: 'sales', name: '销项发票', ops: [V, E, DEL, IMP, EXP, GEN]},
			{code: 'purchase', name: '进项发票', ops: [V, E, DEL, IMP, EXP, GEN]},
			{code: 'smart', name: '智能开票', ops: [INV, IVI, TXI, IVS, IVO, BIV]},
			{code: 'expense', name: '费用单据', ops: [V, E, DEL, EXP, GEN]},
			{code: 'noTicket', name: '无票收入', ops: [V, E, DEL, EXP, GEN]}
		]
	},
	{
		code: 'assets', name: '固定资产', funcs: [
			{code: 'manage', name: '固定资产管理', ops: [V, E, CHG, DSP, GEN, DEL, IMP, EXP, DPR, PRT, MSB, FST]},
			{code: 'category', name: '固定资产类别设置', ops: [V, E, DEL]},
			{code: 'depreciation', name: '折旧明细表', ops: [V, EXP, PRT]},
			{code: 'summary', name: '固定资产汇总', ops: [V, EXP]},
			{code: 'check', name: '固定资产对账', ops: [V, EXP, PRT]}
		]
	},
	{
		code: 'inventory', name: '存货', funcs: [
			{code: 'order', name: '单据管理', ops: [V, E, DEL, GEN]},
			{code: 'fund', name: '资金管理', ops: [V, E, DEL, GEN]},
			{code: 'check', name: '存货盘点', ops: [V, E, DEL, GEN]},
			{code: 'opening', name: '期初数据', ops: [V, E, IMP, EXP]},
			{code: 'basic', name: '基础设置', ops: [V, E]},
			{code: 'report', name: '统计报表', ops: [V, EXP]},
			{code: 'costPeriod', name: '成本核算期间', ops: [V, E, DEL]}
		]
	},
	{
		code: 'carry', name: '期末结转', funcs: [
			{code: 'checkout', name: '期末结账', ops: [V, CKO, UCK]}
		]
	},
	{
		code: 'declare', name: '申报', funcs: [
			{code: 'enterpriseTax', name: '企业税申报', ops: [FET, ONE, TAC]},
			{code: 'personalTax', name: '个税申报', ops: [FIL, ONE]}
		]
	},
	{
		code: 'settings', name: '设置', funcs: [
			{code: 'accountSets', name: '账套', ops: [V, E, DEL, RST]},
			{code: 'subject', name: '科目', ops: [V, E, DEL, IMP, EXP, CST]},
			{code: 'initial', name: '期初', ops: [V, E, IMP, EXP]},
			{code: 'currency', name: '币别', ops: [V, E, DEL]},
			{code: 'voucherWord', name: '凭证字', ops: [V, E, DEL]},
			{code: 'auxiliary', name: '辅助核算', ops: [V, E, DEL, IMP, EXP]},
			{code: 'auxCategory', name: '辅助核算类别', ops: [V, E, DEL]},
			{code: 'permission', name: '权限设置', ops: [V, E, DEL]},
			{code: 'oldSync', name: '旧账同步', ops: [V, IMP]},
			{code: 'backup', name: '备份恢复', ops: [V, E, DEL]},
			{code: 'auditLog', name: '审计日志', ops: [V, EXP]},
			{code: 'auditData', name: '审计数据', ops: [V, EXP]}
		]
	},
	{
		code: 'memo', name: '备忘录', funcs: [
			{code: 'memo', name: '备忘录', ops: [V, E]}
		]
	}
];

/**
 * 模块下所有功能项的 key（含 module.func.op）
 */
export function allKeys() {
	const keys = [];
	TREE.forEach(m => {
		m.funcs.forEach(f => {
			f.ops.forEach(o => {
				keys.push(`${m.code}.${f.code}.${o.code}`);
			});
		});
	});
	return keys;
}

/**
 * key -> 模块中文名
 */
export function keyModuleMap() {
	const map = {};
	TREE.forEach(m => m.funcs.forEach(f => f.ops.forEach(o => {
		map[`${m.code}.${f.code}.${o.code}`] = m.name;
	})));
	return map;
}

/**
 * 根据权限点集合推导模块标签（按 MODULES 顺序去重）
 */
export function modulesOf(keys) {
	const map = keyModuleMap();
	const hit = [];
	(keys || []).forEach(k => {
		const m = map[k];
		if (m && hit.indexOf(m) < 0) {
			hit.push(m);
		}
	});
	return MODULES.filter(m => hit.indexOf(m) > -1);
}
